import { ReactNode } from 'react';

import {
  Box,
  Flex,
  SimpleGrid,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

const ConditionalDetails = ({
  question,
  isOpen,
  title,
  columns = 3,
  children,
}: {
  question: ReactNode;
  isOpen: boolean;
  title: string;
  columns?: number;
  children: ReactNode;
}) => {
  const bg = useColorModeValue('gray.50', 'whiteAlpha.100');
  const borderColor = useColorModeValue('brand.500', 'brand.400');

  if (!isOpen) return <>{question}</>;

  return (
    <Box gridColumn="1 / -1">
      <Flex
        direction={{ base: 'column', lg: 'row' }}
        gap="20px"
        align="flex-start"
      >
        <Box flexShrink={0} w={{ base: '100%', lg: '240px' }}>
          {question}
        </Box>
        <Box
          flex="1"
          w="100%"
          bg={bg}
          borderLeft="3px solid"
          borderColor={borderColor}
          borderRadius="md"
          p="16px"
        >
          <Text fontSize="sm" fontWeight="bold" mb="12px">
            {title}
          </Text>
          <SimpleGrid columns={{ base: 1, md: columns }} spacing="20px">
            {children}
          </SimpleGrid>
        </Box>
      </Flex>
    </Box>
  );
};

export default ConditionalDetails;
